function tagToUrl(params) {
    const { host, tagName, sizeHint = 9999, version = '3.0' } = params;
    const url = new URL(`${host}/${version}/getimage`);
    url.searchParams.append('tag', tagName);
    url.searchParams.append('size_hint', sizeHint.toString());
    return url.toString();
}
function makeTagToUrl(params) {
    return (tagName) => tagToUrl(Object.assign(Object.assign({}, params), { tagName }));
}
export { makeTagToUrl, tagToUrl };
